module.exports = ".nested-menu .list-group-item {\n  cursor: pointer; }\n\n.nested-menu .nested {\n  list-style-type: none; }\n\n.nested-menu ul.submenu {\n  display: none;\n  height: 0; }\n\n.nested-menu .expand ul.submenu {\n  display: block;\n  list-style-type: none;\n  height: auto; }\n\n.nested-menu .expand ul.submenu li a {\n    padding: 10px;\n    display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/sidebar/sidebar.component.scss
// module id = ./src/app/shared/sidebar/sidebar.component.scss
// module chunks = main